import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BookmarkFilledIcon, MoreIcon, TrashIcon } from '../../../assets/icons';
import { useModal } from '../../../hooks';
import { removeOperatorStart } from '../../../redux/operators/operators.actions';
import ConfirmationModal from '../../ConfirmationModal';
import EditOperatorModal from '../EditOperatorModal';
import useTranslation from 'hooks/useTranslation';
import { replaceKeyWithValue } from 'utils/text';

const mapState = (state) => ({
  weeklyChosenOperator: state.operatorsData.weeklyChosenOperator,
  profile: state.userData.profile,
});

const ChosenOperatorHeader = () => {
  const { weeklyChosenOperator, profile } = useSelector(mapState);
  const dispatch = useDispatch();
  const { isCreatorAdmin, userId } = profile;
  const { isCreator, accessLevel, fullName, id } = weeklyChosenOperator;
  const [visible, toggle] = useModal();
  const { getTranslation } = useTranslation('OPERATORS');
  const { t } = getTranslation();

  const handleRemoveOperator = (event) => {
    if (event) event.preventDefault();
    dispatch(removeOperatorStart({ id, fullName }));
  };

  const openConfirmationModal = (event) => {
    if (event) event.preventDefault();
    toggle();
  };

  const renderSettingsOverlay = (
    <div className='operators__list__chosen__top__menu flex flex-jc-e'>
      <div className='operators__list__chosen__top__menu__vertical grid grid-pi-c'>
        <img src={MoreIcon} alt='' />
        <div className='operators__list__chosen__top__menu__vertical__menu'>
          <ul className='operators__list__chosen__top__menu__vertical__menu__inner'>
            <li>
              <EditOperatorModal
                operatorId={weeklyChosenOperator.id}
                isWeeklyChosen
              />
            </li>
            {((!isCreatorAdmin && accessLevel === 'user') ||
              (isCreatorAdmin && !isCreator)) && (
              <li>
                <a
                  href='#/'
                  className='flex'
                  rel='noopener noreferrer'
                  onClick={openConfirmationModal}
                >
                  <img src={TrashIcon} alt='' />
                  <p>{t('DELETE_OPERATOR')}</p>
                </a>
                <ConfirmationModal
                  message={replaceKeyWithValue(
                    t('DELETE_OPERATOR_CONFIRM'),
                    'name',
                    fullName
                  )}
                  onConfirm={handleRemoveOperator}
                  visible={visible}
                  toggle={toggle}
                />
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );

  return (
    <div className='operators__list__chosen__top'>
      <div className='operators__list__chosen__top__bookmark'>
        <img src={BookmarkFilledIcon} alt='' />
      </div>
      {(!isCreator || id === userId) && renderSettingsOverlay}
      {isCreator && id !== userId && <div style={{ height: '2rem' }}></div>}
    </div>
  );
};

export default ChosenOperatorHeader;
